import { createIconComponent } from '../../factory/create-icon-component';
export const UAEIcon = createIconComponent(
  'UAEIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28288)">
      <path d="M23 5H1V20H23V5Z" fill="#F0F0F0" />
      <path d="M23 5H1V9.99982H23V5Z" fill="#6DA544" />
      <path d="M23 14.9996H1V19.9995H23V14.9996Z" fill="black" />
      <path d="M8.33317 5H1V20H8.33317V5Z" fill="#A2001D" />
    </g>
    <defs>
      <clipPath id="clip0_4605_28288">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
